module.exports = __webpack_public_path__ + "assets/img/Claim_btn.6a5359fa.png";